import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import RffDateField from "../components/finalForm/inputs/RffDateField";
import RffEmailField from "../components/finalForm/inputs/RffEmailField";
import RffPhoneField from "../components/finalForm/inputs/RffPhoneField";
import RffSelectToggleField from "../components/finalForm/inputs/RffSelectToggleField";
import RffSsnField from "../components/finalForm/inputs/RffSsnField";
import RffTextField from "../components/finalForm/inputs/RffTextField";
import RffFormChanges from "../components/finalForm/RffFormChanges";
import RffGroup from "../components/finalForm/shared/RffGroup";
import { selectOptionsCitizenshipStatus } from "../constants/selectOptions/selectOptionsCitizenshipStatus";
import { selectOptionsMaritalStatus } from "../constants/selectOptions/selectOptionsMaritalStatus";
import { useBorrowerPortalHook } from "../hooks/useBorrowerPortalHook";
import { profileSet } from "../redux/actions/profileActions";
import { sidebarClose } from "../redux/reducers/sidebarReducer";
import RffAddressEditingField from "../components/finalForm/inputs/RffAddressEditingField";
import RffSelectField from "../components/finalForm/inputs/RffSelectField";

const UpdateBorrowerProfileDataForm = ({}) => {
  const { loading, updateBorrowerProfile } = useBorrowerPortalHook();
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);
  const onSubmit = (changedValues, { form, values, changes }) => {
    // const payload = [{ _id: file._id || file?.oid, ...changedValues }];
    // updateProfileDocuments({
    //   files: payload,
    //   onSuccessFn: () => {
    //     dispatch(sidebarClose());
    //   },
    // });

    // console.log("changedValues", changedValues);
    // return;
    updateBorrowerProfile({
      data: changedValues,
      onSuccessFn: (d) => {
        // console.log("Profile updated successfully", d);
        dispatch(profileSet(d)); // Use the current form values, not EX_USER_DATA_UPDATED
        // dispatch(profileSet(EX_USER_DATA_UPDATED)); // Use the current form values, not EX_USER_DATA_UPDATED
        dispatch(sidebarClose());
      },
    });
  };

  const initialValues = useMemo(() => {
    return profile;
  }, [profile]);

  return (
    <RffFormChanges
      loading={loading}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      <ProfileFormQuestions />
    </RffFormChanges>
  );
};

const ProfileFormQuestions = ({ children }) => {
  return (
    <>
      <RffGroup title="Personal Information">
        <RffTextField
          size={6}
          label="First Name"
          name="firstName"
          type="text"
        />
        <RffTextField size={6} label="Last Name" name="lastName" type="text" />
        <RffTextField label="Middle Name" name="middleName" type="text" />

        <RffSsnField size={6} label="SSN" name="borrowerSSN" type="ssn" />
        <RffDateField
          size={6}
          label="Date of Birth"
          name="dateOfBirth"
          type="date"
        />

        <RffSelectField
          size={6}
          label="Marital Status"
          name="maritalStatus"
          type="select"
          options={selectOptionsMaritalStatus}
        />
        <RffSelectField
          size={6}
          label="Citizenship Status"
          name="citizenshipStatus"
          type="select"
          options={selectOptionsCitizenshipStatus}
          isLast
        />
      </RffGroup>
      <RffGroup title="Contact Information">
        <RffEmailField
          label="Email Address"
          name="emailAddress"
          type="email"
          disabled
        />
        <RffPhoneField label="Phone Number" name="phone" type="phone" />
      </RffGroup>
      <RffGroup title="Primary Address">
        <RffAddressEditingField label="Primary Address" name="primaryAddress" />
      </RffGroup>
    </>
  );
};
export default UpdateBorrowerProfileDataForm;
